/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Sales Call Grader API
 * AI-powered sales enablement platform
 * OpenAPI spec version: 2.0.0
 */

/**
 * Hanover sales-process deal stages (overall opportunity position).
 */
export type DealStage = (typeof DealStage)[keyof typeof DealStage];

export const DealStage = {
  Identify: "Identify",
  Qualify: "Qualify",
  Advance: "Advance",
  Propose: "Propose",
  Close: "Close",
  Expand: "Expand",
} as const;
